import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Typography
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    ZPlayLoader,
    NavigationBack
} from "commons";

import { ManageSeriesState } from "./models";
import { DefaultTypedResponse } from "models/response";
import { Series } from "models";

import { ContentProducerService } from "services/content-producer-service";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { SeriesTable } from "components/backoffice/series";
import { RouteComponentProps, withRouter } from "react-router-dom";


class ManageSeries extends React.Component<UseFormReturn & WithSnackbarProps & RouteComponentProps, ManageSeriesState> {

    constructor(props: any) {
        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            seriesCount: 0,
            seriesList: [],
            data: null,
            isLoading: true,
            openEditSeriesModal: false,
            openCreateSeriesModal: false,
            editSeries: null
        };
    }


    public componentDidMount() {
        this.getPaginatedSeriesWithStateParameters();
    };

    private paginationUpdated = (pagination: any) => {

        ////****
        //VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
        ////****

        this.setState(
            () => ({
                isLoading: true,
                pagination: pagination
            }),
            () => ContentProducerService.getSeriesListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getSeriesCallback, this.getSeriesErrorCallback)
        );

    }

    private getPaginatedSeriesWithStateParameters = () => {

        this.setState(() => ({
            isLoading: true,
        }));

        ContentProducerService.getSeriesListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getSeriesCallback, this.getSeriesErrorCallback);
    }

    private deleteSeries = (id: string): void => {

        this.setState(() => ({
            isLoading: true,
        }));

        if ((this.state.seriesList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        };

        ContentProducerService.deleteSeries(id, this.getPaginatedSeriesWithStateParameters, this.deleteSeriesErrorCallback);
    }


    private getSeriesCallback = (data: DefaultTypedResponse<Series>): void => {

        this.setState(() => ({
            seriesCount: data.size,
            seriesList: data.list,
            isLoading: false,
        }));
    };

    private editSeriesCallback = (): void => {
        this.setState(() => ({ openEditSeriesModal: false }));
        this.getPaginatedSeriesWithStateParameters();
    };

    private createSeriesCallback = (): void => {
        this.setState(() => ({ openCreateSeriesModal: false }));
        this.getPaginatedSeriesWithStateParameters();
    };

    private deleteSeriesErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "st-error-delete-series",
            message: "Si è verificato un errore. Il series non è stato eliminato"
        }), {
            variant: "error",
        });
    }

    private getSeriesErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "st-error-get-series",
            message: "Si è verificato un errore."
        }), {
            variant: "error",
        });
    };

    private editSeriesErrorCallback = (err: any): void => {
        this.setState(() => ({
            openEditSeriesModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "st-error-edit-series",
            message: "Si è verificato un errore. Il series non è stato modificato"
        }), {
            variant: "error",
        });
    };

    private createSeriesErrorCallback = (err: any): void => {
        this.setState(() => ({
            openCreateSeriesModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "st-error-create-series",
            message: "Si è verificato un errore. Il series non è stato creato"
        }), {
            variant: "error",
        });
    };


    private openEditSeriesModal = (series: Series): void => {
        this.setState(() => ({
            openEditSeriesModal: true,
            editSeries: series
        })
        )
    }

    private closeModal = (): void => {
        this.setState(() => ({
            openEditSeriesModal: false,
            editSeries: null,
            openCreateSeriesModal: false
        }));
    };

    private openCreateSeriesModal = (): void => {
        let { history } = this.props
        history.push("/backoffice/create-series");
    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack />
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="st-text-title">Serie</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.openCreateSeriesModal}
                        variant={"contained"}
                    >
                        <Trans id="st-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {<Box sx={{ p: 2, mt: 2 }}>
                    <SeriesTable
                        pagination={this.state.pagination}
                        seriess={this.state.seriesList}
                        totalSeriesCount={this.state.seriesCount}
                        deleteSeries={this.deleteSeries}
                        openEditSeriesTable={this.openEditSeriesModal}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withRouter(withSnackbar(ManageSeries));